import {
    initialBrandStrollersListState,
    initialBrandsStrollersListState,
} from "@/mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersList.constants";
import { AppState } from "@/mk2/reducers";

export const getBrandStrollersListState = (state: AppState, slug: string) => {
    const brandsStrollersListPageState = getBrandsStrollersListState(state);
    return brandsStrollersListPageState.brands[slug] || initialBrandStrollersListState;
};

export const getBrandsStrollersListState = (state: AppState) =>
    state.containers.strollers.brandsStrollersList || initialBrandsStrollersListState;
